export default __webpack_public_path__ + "static/media/proposal-side-image.9d0a6361.png";